import { useMemo } from 'react';
import { createBrowserRouter } from 'react-router';
import { RouterProvider } from 'react-router/dom';

import { selectIdentityKey, selectRole, useSession } from '@shared/session';

import { createRoutes } from './create-routes';

/**
 * 부팅이 끝난 뒤에만 그려진다(BootGate 안).
 * 신원(사용자 · 역할)이 바뀌면 라우터를 새로 만들고 `key` 로 트리를 다시 마운트한다
 * — 컴포넌트 로컬 상태까지 버리고, 새 역할에 없는 경로의 NotFound 깜빡임을 막는다.
 */
export function AppRouter() {
  const role = useSession(selectRole);
  const identityKey = useSession(selectIdentityKey);

  const router = useMemo(
    () => createBrowserRouter(createRoutes({ role })),
    // identityKey 가 바뀌면(같은 역할의 다른 사용자 포함) 새로 만든다.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [role, identityKey],
  );

  return <RouterProvider key={identityKey} router={router} />;
}
